import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .select {
      h4 { 
         white-space: nowrap;
         width: 130px; 
      }
   }
   /* Mode selector styling */
   .mode-selector {
      margin-bottom: 15px;
   }
   
   /* Fix for Select component label */
   > div:first-child {
      margin-bottom: 15px;
      
      /* Make label not wrap */
      label, span {
         white-space: nowrap;
      }
   }

   /* Cache & Scroll Settings */
   .settings-row {
      display: flex;
      align-items: center;
      gap: 15px;
      margin-bottom: 15px;
   }

   .cache-toggle {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 12px;
      background-color: #f8f9fa;
      border-radius: 8px;
      
      .cache-label {
         font-size: 13px;
         font-weight: 500;
         color: #333;
      }
      
      .toggle-switch {
         width: 44px;
         height: 24px;
         background-color: #ccc;
         border-radius: 12px;
         cursor: pointer;
         position: relative;
         transition: background-color 0.2s ease;
         
         &.active {
            background-color: #22c55e;
         }
         
         .toggle-slider {
            position: absolute;
            top: 2px;
            left: 2px;
            width: 20px;
            height: 20px;
            background-color: white;
            border-radius: 50%;
            transition: transform 0.2s ease;
            box-shadow: 0 2px 4px rgba(0,0,0,0.2);
         }
         
         &.active .toggle-slider {
            transform: translateX(20px);
         }
      }
      
      .cache-hint {
         font-size: 11px;
         color: #666;
         font-style: italic;
      }
   }

   .scroll-count {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 10px 12px;
      background-color: #f8f9fa;
      border-radius: 8px;

      span {
         font-size: 13px;
         font-weight: 500;
         color: #333;
      }

      input {
         width: 100%;
         height: 24px;
         border: 1px solid #ccc;
         border-radius: 4px;
         padding: 0 8px;
         font-size: 13px;
         background-color: white;
         outline: none;

         &:focus {
            border-color: #2eb907ff;
         }
      }
   }
   
   .add {
      display: flex;
      align-items: center;
      position: relative;
      margin-bottom: 15px;

      input {
         width: 100%;
         height: 40px;
         border: none;
         background-color: rgb(245, 245, 245);
         border-radius: 25px;
         font-size: 15px;
         padding: 0 48px 0 15px;
         color: #696F74;

         &::placeholder {
            color: #000;
            opacity: 0.5;
         }
      }
      svg {
         position: absolute;
         right: 15px;
         opacity: 0.3;
      }
   }
   
   /* URL Library Section */
   .library-section {
      margin-bottom: 15px;
      position: relative;
      
      .library-button {
         display: flex;
         align-items: center;
         gap: 8px;
         padding: 10px 15px;
         background-color: #e8f4fd;
         border-radius: 8px;
         cursor: pointer;
         font-size: 13px;
         color: #1976d2;
         transition: all 0.2s ease;
         
         &:hover {
            background-color: #d0e8f9;
         }
         
         svg {
            font-size: 12px;
         }
      }
      
      .library-dropdown {
         position: absolute;
         top: 100%;
         left: 0;
         right: 0;
         background: white;
         border: 1px solid #e0e0e0;
         border-radius: 8px;
         box-shadow: 0 4px 12px rgba(0,0,0,0.15);
         z-index: 100;
         max-height: 200px;
         overflow-y: auto;
         margin-top: 4px;
      }
      
      .library-item {
         display: flex;
         align-items: center;
         justify-content: space-between;
         padding: 10px 12px;
         cursor: pointer;
         border-bottom: 1px solid #f0f0f0;
         transition: background-color 0.2s ease;
         
         &:hover {
            background-color: #f5f5f5;
         }
         
         &:last-child {
            border-bottom: none;
         }
         
         .library-url {
            font-size: 12px;
            color: #333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 200px;
         }
         
         .library-mode {
            font-size: 10px;
            font-weight: 600;
            padding: 2px 6px;
            border-radius: 4px;
            color: white;
            
            &.normal {
               background-color: #3b82f6;
            }
            
            &.vlm {
               background-color: #8b5cf6;
            }
         }
      }
      
      .library-empty {
         padding: 15px;
         text-align: center;
         font-size: 12px;
         color: #666;
         font-style: italic;
      }
   }
   
   .items {
      margin-top: 10px;
      
      .title {
         display: flex;
         align-items: center;
         margin-bottom: 8px;
         
         h4 { 
            font-weight: 400; 
            margin: 0;
         }
         span { 
            opacity: 0.5; 
            margin-left: 7.5px; 
            font-size: 14px;
         }
      }
      ul {
         margin: 0;
         padding: 0;
         list-style: none;
         overflow: auto;
         max-height: 150px;

         li {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #F6F6F6;
            padding: 0 15px;
            font-size: 14px;
            border-radius: 8px;
            height: 40px;

            &:not(:last-of-type) {
               margin-bottom: 8px;
            }
            > span:first-of-type {
               opacity: 0.8;
               white-space: nowrap;
               overflow: hidden;
               text-overflow: ellipsis;
               max-width: 250px;
            }
            .remove {
               position: absolute;
               top: 0;
               right: 0;
               display: none;
               align-items: center;
               justify-content: center;
               padding: 0 12px;
               height: 100%;
               color: #F05454;
               transition: all .2s ease-in-out;
               background-color: #F6F6F6;
               border-radius: 0 8px 8px 0;
               cursor: pointer;
               font-size: 16px;

               &:hover {
                  opacity: 0.7;
               }
            }
            &:hover .remove {
               display: flex;
            }
         }
      }
   }
`;